import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Form, Card, Button, Breadcrumb, Table, Modal, Badge } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getPendingLeaves, processLeaveApproval, getLeaveDocument } from "../../../../api/onboarddeboard";

const validateRemark = (value) => {
  const trimmed = value.trim();
  if (/^\s+$/.test(value)) return "Remark cannot contain only empty spaces";
  if (!trimmed) return "Remark is required";
  if (/^\d+$/.test(trimmed)) return "Remark cannot contain only numbers";
  if (/^[^a-zA-Z0-9]+$/.test(trimmed)) return "Remark cannot contain only special characters";
  if (/^[^a-zA-Z]*$/.test(trimmed) && /[0-9]/.test(trimmed) && /[^a-zA-Z0-9]/.test(trimmed))
    return "Remark cannot contain only numbers and special characters";
  if (trimmed.length > 500) return "Remark cannot exceed 500 characters.";
  return "";
};

const LeaveApproval = () => {
  const token = localStorage.getItem("token");
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [action, setAction] = useState("");
  const [remark, setRemark] = useState("");
  const [remarkError, setRemarkError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [showDocModal, setShowDocModal] = useState(false);
  const [docUrl, setDocUrl] = useState(null);
  const [docType, setDocType] = useState("");

const [showReasonModal, setShowReasonModal] = useState(false);
const [reasonLeave, setReasonLeave] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    getPendingLeaves(token)
      .then((r) => setPending(r.data || []))
      .catch(() => toast.error("Failed to load pending leave approvals."))
      .finally(() => setLoading(false));
  }, [token]);

  useEffect(() => { if (token) load(); }, [token, load]);

  const openModal = (leave, act) => {
    setSelected(leave); setAction(act); setRemark(""); setRemarkError(""); setShowModal(true);
  };
  const closeModal = () => { setShowModal(false); setSelected(null); setAction(""); setRemark(""); setRemarkError(""); };

  const handleRemarkChange = (e) => {
    const value = e.target.value;
    setRemark(value);
    setRemarkError(value ? validateRemark(value) : "");
  };

  const handleSubmit = async () => {
    const err = validateRemark(remark);
    if (err) { setRemarkError(err); return; }
    setSubmitting(true);
    try {
      await processLeaveApproval({ leaveApplicationId: selected.id, action, remark: remark.trim() }, token);
      toast.success(action === "APPROVE" ? "Leave approved successfully" : "Leave rejected successfully");
      closeModal();
      load();
    } catch (err) {
      toast.error(err?.response?.data || "Failed to process leave approval.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleViewDocument = async (id) => {
    try {
      const res = await getLeaveDocument(id, token);
      setDocUrl(URL.createObjectURL(res.data));
      setDocType(res.data.type);
      setShowDocModal(true);
    } catch {
      toast.error("Failed to load document.");
    }
  };
  const closeDocModal = () => { if (docUrl) URL.revokeObjectURL(docUrl); setDocUrl(null); setDocType(""); setShowDocModal(false); };

  const formatDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB") : "-");

  return (
    <Container fluid className="p-4">
      <style>{`
        .lc-breadcrumb a { text-decoration: none !important; color: #2E5CB8 !important; }
        .lc-breadcrumb .breadcrumb-item.active { color: #6c757d !important; }
        .pagination .page-item.active .page-link { background-color: #2E5CB8 !important; border-color: #2E5CB8 !important; }
      `}</style>
      <ToastContainer position="top-right" autoClose={3000} />

      <h4 className="page-main-heading" style={{ marginBottom: 12 }}>Leave Approval</h4>
      <Breadcrumb className="lc-breadcrumb">
        <Breadcrumb.Item href="#">Leave</Breadcrumb.Item>
        <Breadcrumb.Item href="#">Leave Application</Breadcrumb.Item>
        <Breadcrumb.Item active>Leave Approval</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col xl={12}>
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Pending Leave Applications</h5>
              <Badge bg="secondary">Total: {pending.length}</Badge>
            </Card.Header>
            <Card.Body>
              <Table bordered hover responsive>
                <thead>
                  <tr>
                    {["Sr.No", "Employee", "Leave Type", "FromDate", "ToDate", "Days", "Reason", "Document", "Applied On", "Action"].map((h) => (
                      <th key={h} style={{ backgroundColor: "#2E5CB8", color: "white", whiteSpace: "nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading && <tr><td colSpan={10} className="text-center py-4"><div className="text-muted">Loading...</div></td></tr>}
                  {!loading && pending.length === 0 && (
                    <tr><td colSpan={10} className="text-center py-4"><div className="text-muted">No pending leave applications</div></td></tr>
                  )}
{!loading && pending.map((l, index) => (
<tr key={l.id}>
  <td>{index + 1}</td>
  <td>{l.employeeName}</td>
                      <td><span className="badge" style={{ backgroundColor: l.leaveTypeColor || "#2E5CB8" }}>{l.leaveTypeName}</span></td>
                      <td>{formatDate(l.fromDate)}</td>
                      <td>{formatDate(l.toDate)}</td>
                      <td>{l.totalDays}</td>
<td style={{ maxWidth: 220 }}>
  {l.reason && l.reason.length > 20 ? (
    <>
      {l.reason.slice(0, 20)}...{" "}
      <Button
        variant="link"
        size="sm"
        className="p-0"
        style={{ fontSize: 13, verticalAlign: "baseline", textDecoration: "none", color: "#2E5CB8" }}
        onClick={() => { setReasonLeave(l); setShowReasonModal(true); }}
      >
        Read more
      </Button>
    </>
  ) : (
    l.reason
  )}
</td>                      <td>
                        {l.documentName ? (
                          <Button variant="link" size="sm" className="p-0" onClick={() => handleViewDocument(l.id)}>
                            <i className="bi bi-file-earmark-text fs-5" style={{ color: "#2E5CB8" }} />
                          </Button>
                        ) : "—"}
                      </td>
                      <td>{formatDate(l.createdAt)}</td>
                      <td style={{ whiteSpace: "nowrap", width: 120 }}>
                        <Button variant="success" size="sm" className="me-2" style={{ padding: "3px 8px", fontSize: 12 }} onClick={() => openModal(l, "APPROVE")}>Approve</Button>
                        <Button variant="danger" size="sm" style={{ padding: "3px 8px", fontSize: 12 }} onClick={() => openModal(l, "REJECT")}>Reject</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{action === "APPROVE" ? "Approve Leave" : "Reject Leave"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selected && (
            <>
              <p><strong>Employee:</strong> {selected.employeeName}</p>
              <p><strong>Leave Type:</strong> {selected.leaveTypeName}</p>
              <p><strong>Duration:</strong> {formatDate(selected.fromDate)} to {formatDate(selected.toDate)}</p>
              <Form.Group>
                <Form.Label>Remark <span className="text-danger">*</span></Form.Label>
                <Form.Control as="textarea" rows={4} value={remark} onChange={handleRemarkChange} maxLength={500} placeholder="Enter remark" />
                <div className="d-flex justify-content-between mt-1">
                  <span style={{ color: "red", fontSize: 13 }}>{remarkError}</span>
                  <small className="text-muted">{remark.length}/500</small>
                </div>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={closeModal}>Cancel</Button>
          <Button variant="primary" size="sm" style={{ backgroundColor: "#2E5CB8", borderColor: "#2E5CB8" }} onClick={handleSubmit} disabled={submitting}>
            {submitting ? "Processing..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDocModal} onHide={closeDocModal} size="lg" centered>
        <Modal.Header closeButton><Modal.Title><i className="bi bi-file-earmark-text me-2" />Document Viewer</Modal.Title></Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflow: "auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {docUrl && (docType.startsWith("image/") ? (
            <img src={docUrl} alt="Document" style={{ maxWidth: "100%", maxHeight: "60vh", objectFit: "contain" }} />
          ) : (
            <iframe src={docUrl} style={{ width: "100%", height: "60vh", border: "none" }} title="Document Viewer" />
          ))}
        </Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={closeDocModal}>Close</Button></Modal.Footer>
      </Modal>

      <Modal show={showReasonModal} onHide={() => { setShowReasonModal(false); setReasonLeave(null); }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Leave Reason</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {reasonLeave && (
            <>
              <p className="mb-2"><strong>Employee:</strong> {reasonLeave.employeeName}</p>
              <p className="mb-2"><strong>Leave Type:</strong> {reasonLeave.leaveTypeName}</p>
              <p className="mb-1"><strong>Reason:</strong></p>
              <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", background: "#f8f9fa", border: "1px solid #e5e7eb", borderRadius: 6, padding: 12 }}>
                {reasonLeave.reason}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => { setShowReasonModal(false); setReasonLeave(null); }}>Close</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default LeaveApproval;